(() => {
  const root = document.querySelector('[data-welcome-offer]');
  if (!root) return;
  const dialog = root.querySelector('[data-welcome-dialog]');
  if (!dialog || typeof dialog.show !== 'function') return;
  const tab = root.querySelector('[data-welcome-reopen]');
  const backdrop = root.querySelector('[data-welcome-backdrop]');
  // Keep Shopify's external CAPTCHA interactive. Native showModal() makes its
  // body-level iframe inert and places the popup above the verification challenge.
  const background = Array.from(document.querySelectorAll('main, body > .shopify-section-group-header-group, body > .shopify-section-group-footer-group'));
  let previousInert = [];
  const key = 'refine-welcome-v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (_) { return {}; } };
  const remember = (value) => { try { localStorage.setItem(key, JSON.stringify({ ...read(), ...value })); } catch (_) {} };
  const hasSuccess = !!document.querySelector('[data-welcome-success]');
  if (hasSuccess) remember({ subscribed: true });
  let previousFocus;
  let timer;
  const open = () => {
    if (dialog.open) return;
    clearTimeout(timer);
    previousFocus = document.activeElement;
    previousInert = background.map((element) => element.inert);
    background.forEach((element) => { element.inert = true; });
    dialog.show();
    backdrop.hidden = false;
    document.body.classList.add('welcome-offer-open');
    tab.hidden = true;
    dialog.querySelector('[data-welcome-close]').focus();
  };
  const close = () => dialog.close();
  dialog.addEventListener('close', () => {
    document.body.classList.remove('welcome-offer-open');
    backdrop.hidden = true;
    background.forEach((element, index) => { element.inert = previousInert[index]; });
    remember({ dismissedUntil: Date.now() + 7 * 24 * 60 * 60 * 1000 });
    tab.hidden = hasSuccess || read().subscribed === true;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  });
  root.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', close));
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const controls = Array.from(dialog.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex="0"]')).filter((element) => !element.disabled && element.getClientRects().length > 0);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', (event) => { if (event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  } });
  tab.addEventListener('click', open);
  // Native Shopify forms retain their form ID in the return URL, including challenge redirects.
  const ownResult = root.querySelector('[data-welcome-result]');
  if (ownResult && location.hash === '#RefineWelcomeForm') { open(); return; }
  if (hasSuccess || read().subscribed === true) return;
  tab.hidden = false;
  if (root.dataset.designMode === 'true' || read().dismissedUntil > Date.now()) return;
  const delay = Math.max(10, Number(root.dataset.delay) || 25) * 1000;
  let started = Date.now();
  try {
    started = Number(sessionStorage.getItem(key)) || started;
    sessionStorage.setItem(key, String(started));
  } catch (_) {}
  const attempt = () => {
    if (read().subscribed === true) { tab.hidden = true; return; }
    if (read().dismissedUntil > Date.now()) return;
    // Let customers finish typing and using menus or product configurators.
    if (document.hidden || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]') || document.querySelector('dialog[open], .menu-open, [data-mobile-menu][aria-hidden="false"]')) {
      timer = setTimeout(attempt, 5000);
      return;
    }
    open();
  };
  timer = setTimeout(attempt, Math.max(0, delay - (Date.now() - started)));
})();
